module.exports = __webpack_public_path__ + "img/传统生产1.5bee74e8.png";